import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/landing.css';

const Home = () => {
  return (
    <div className="landing-page">
      <header className="hero">
        <h1>Helping you make informed decisions.</h1>
        <p>Track, analyse and report on print media mentions with precision — powered by intelligent monitoring technology.</p>
        <div className="cta-buttons">
          <Link to="/login" className="btn-primary">
            Get Started
          </Link>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </header>

      <section className="features">
        <div className="feature">
          <h3>What We Do</h3>
          <p>
            We track and analyse mentions of brands, clients or industry topics in printed publications — newspapers, magazines and journals — delivering actionable intelligence to your dashboard.
          </p>
        </div>
        <div className="feature">
          <h3>How It Works</h3>
          <p>
            1. We identify publications: daily, weekly, bi-weekly, monthly.<br/>
            2. We gather your keywords and phrases to monitor.<br/>
            3. Publications are uploaded and processed.<br/>
            4. Content is extracted using advanced methods to derive sentiment.<br/>
            5. Reports are generated from the analysis.
          </p>
        </div>
        <div className="feature">
          <h3>Data Analytics</h3>
          <p>
            Comprehensive media monitoring and analysis across print, broadcast, online, and social media — helping businesses make informed decisions about their market strategy.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
